import { Component } from '@angular/core';
import { BasePage } from '../../BasePage';

@Component({
  selector: 'app-restricted',
  templateUrl: './restricted.component.html',
  standalone: false,
})
export class RestrictedComponent extends BasePage {}
